<template>
    <!-- bottom-inset="54" (zadani uzivatele 2026-08-19 - "SkillPicker je
         trochu tou listou zakryvany, tak o 5-10px") - fullHeight
         ResponsiveDialog bez teto propsy pocita vysku jen procentualne
         (88vh), vubec nepocita s fixni 46px team-sheet-peek listou (z-index
         900) dole - stejna konvence uz existuje u jinych fullHeight dialogu
         (CityHealDialog/CityTravelDialog/PlayerChatPopup/OfficerJennyDialog). -->
    <ResponsiveDialog :value="value" @input="$emit('input', $event)" :max-width="480" :bottom-inset="54" :header-title="headerTitle" header-class="skin-window-header--skillpicker" :card-class="cardClass">
        <div class="skill-picker-bg skin-window--skillpicker">
            <p v-if="roundRoleHint" class="skill-picker-hint">{{ roundRoleHint }}</p>
            <!-- Filtr podle tagu (zadani uzivatele 2026-08-20 - "co nejvic
                 informaci na prvni dobrou... filtry podle tagu s AND/OR").
                 Skryty za tlacitkem, ne rovnou rozbaleny - vetsinou skill jen
                 vyberes bez filtrovani, chip-row navic by na uzoucim mobilu
                 zabral radky navic porad. -->
            <div class="skill-picker-filter-bar">
                <v-chip
                    small
                    outlined
                    :color="$vuetify.theme.dark ? 'white' : undefined"
                    class="skill-picker-filter-toggle"
                    @click="filtersOpen = !filtersOpen"
                >
                    <v-icon size="15" left>mdi-filter-variant</v-icon>
                    {{ $t('journey.skillPicker.filtersLabel') }}<template v-if="selectedTags.length"> ({{ selectedTags.length }})</template>
                    <v-icon size="15" right>{{ filtersOpen ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                </v-chip>
                <v-expand-transition>
                    <div v-if="filtersOpen" class="skill-picker-filter-panel">
                        <v-chip-group v-model="selectedTags" multiple column active-class="skill-picker-chip--active">
                            <v-chip
                                v-for="tag in allTags"
                                :key="tag.id"
                                :value="tag.id"
                                :style="tag.type ? typeChipStyle(tag.type) : null"
                                small
                            >
                                <v-icon v-if="tag.icon" size="13" left>{{ tag.icon }}</v-icon>
                                {{ tag.label }}
                            </v-chip>
                        </v-chip-group>
                        <!-- AND/OR ma smysl az od 2 vybranych tagu (zadani
                             uzivatele - "vybere si po vsechny and nebo or"). -->
                        <v-btn-toggle v-if="selectedTags.length >= 2" v-model="filterMode" mandatory dense class="skill-picker-filter-mode">
                            <v-btn small value="OR">{{ $t('journey.skillPicker.anyOr') }}</v-btn>
                            <v-btn small value="AND">{{ $t('journey.skillPicker.allAnd') }}</v-btn>
                        </v-btn-toggle>
                    </div>
                </v-expand-transition>
            </div>
            <div class="skill-picker-list">
                <div
                    v-for="skill in filteredSkills"
                    :key="skill.id"
                    class="skill-picker-row"
                    :class="{'skill-picker-row--disabled': skill.disabled, 'skill-picker-row--dark': $vuetify.theme.dark}"
                    @click="choose(skill)"
                >
                    <!-- Explicitni color (2026-08-05, nalez uzivatele - ikona
                         byla v dark theme bila/necitelna) - .skill-picker-row
                         melo tehdy VZDY svetle pozadi bez ohledu na theme,
                         takze ikona bez explicitni barvy spadla na Vuetify
                         vlastni dark-theme default (bila) misto na skutecne
                         pozadi pod ni. 2026-08-11: .skill-picker-row uz MA
                         tmavou varintu (--dark modifikator nize), takze barva
                         ikony se musi ridit stejnou podminkou jako pozadi/text
                         retezce vedle ni, jinak by v dark theme byla cerna
                         ikona na cernem pozadi (stejna trida chyby, zadani
                         uzivatele - "pokud se meni pozadi, musi se menit
                         inverzne i text/ikony vevnitr"). -->
                    <v-icon size="18" class="mr-2" :color="$vuetify.theme.dark ? 'white' : 'black'">{{ skill.defence > 0 ? (skill.defence > 1 ? 'mdi-shield-half-full' : 'mdi-laser-pointer') : 'mdi-sword-cross' }}</v-icon>
                    <span class="skill-picker-name">{{ skill.name }}</span>
                    <span class="skill-picker-dmg">{{ skill.minDmg }} - {{ skill.maxDmg }}</span>
                    <!-- Poradi sloupcu (zadani uzivatele 2026-08-20, ctvrte
                         kolo - "dmg prvni, pak area/pierce ikonku, pak efekt,
                         pak typ"). Area je vzdy vlevo od pripadne dalsi
                         ikonky efektu, kdyz ma skill obe ("area i pierce...
                         area vic vlevo"). -->
                    <v-icon v-if="skill.spread" size="13" class="mr-1 skill-picker-inline-icon" :color="$vuetify.theme.dark ? 'white' : 'black'">mdi-earth</v-icon>
                    <!-- Ma-li efekt vlastni ikonu (HEAL/PIERCING/LUNGE), ta uz
                         sama napovida O CO jde - vedle ni tak staci jen holá
                         ciselna hodnota (effectValue), ne cely "PIERCING +2"
                         popisek (zadani uzivatele - "ze jde o pierce ukaze uz
                         samotna ikonka", usetri misto na ultra uzkych
                         rozlisenich). Efekty BEZ vlastni ikony (STUN/
                         REFLECT/METRONOM/LIFESTEAL) nemaji cim naznacit typ,
                         proto tam zustava plny getEffectFormula() text. -->
                    <template v-if="effectIcon(skill)">
                        <v-icon size="13" class="mr-1 skill-picker-inline-icon" :color="$vuetify.theme.dark ? 'white' : 'black'">{{ effectIcon(skill) }}</v-icon>
                        <span class="skill-picker-effect-value">{{ effectValue(skill) }}</span>
                    </template>
                    <span v-else-if="skill.effect" class="skill-picker-effect">{{ getEffectFormula(skill) }}</span>
                    <span class="skill-picker-formula">{{ skill.formula }}</span>
                    <!-- Uplne vpravo v radku (zadani uzivatele 2026-08-20,
                         druhe kolo - "typ utoku dej uplne v pravo"), za
                         vsemi ostatnimi vlastnostmi. -->
                    <TypePill v-if="skill.type" :type="skill.type" size="x-small">{{ skill.type.id }}</TypePill>
                </div>
                <div v-if="skills.length === 0" class="skill-picker-empty">{{ $t('journey.skillPicker.noUsableSkills') }}</div>
                <div v-else-if="filteredSkills.length === 0" class="skill-picker-empty">{{ $t('journey.skillPicker.noSkillMatchesFilter') }}</div>
            </div>
        </div>
    </ResponsiveDialog>
</template>

<script>
    // Sdileny fullscreen picker pro vyber skillu (M3 mobilni redesign, faze 1
    // druhe kolo, zadani uzivatele 2026-07-22 - "kdyz kliknu na selectbox
    // skillu, chci full nebo alespon spodni half full popup se skillama").
    // Nahrazuje inline Vuetify v-select ve FightReport.vue (a pripadne
    // ObstacleSkillPicker.vue pozdeji, viz battle-screen-design.md faze 3) -
    // jen VYBER skillu, samotne "Use skill"/"Base move" tlacitka zustavaji
    // na volajicim (stejne API/flow jako drive, jen mechanismus vyberu je jiny).
    //
    // Filtr podle tagu (2026-08-20, zadani uzivatele) - cisty client-side,
    // skilly uz jsou cele natazene v props. Tagovy katalog cte skutecna pole
    // skillu (spread/effect/defence, viz PokemonTypeSkill.php) - zadny
    // vymysleny tag navic. Typove pilulky jsou na rozdil od pevneho katalogu
    // dynamicke (jen typy, ktere se v aktualnim seznamu skutecne vyskytuji).
    import ResponsiveDialog from '@/components/utils/ResponsiveDialog';
    import TypePill from '@/components/utils/TypePill';
    import {getEffectFormula, effectIcon, effectValue, EFFECT_ICONS} from '@/utils/skillDisplay';
    import {typeChipStyle} from '@/utils/typeColorEnum';

    // Ikony effektovych tagu odvozene primo z EFFECT_ICONS v skillDisplay.js
    // (zadani uzivatele 2026-08-20, ctvrte kolo - stejna ikona pro tag i pro
    // radek/trigger), aby nevznikaly dve rucne synchronizovane kopie. Area/
    // dodge/shield nejsou effect-based (spread/defence), tam icon zustava
    // vlastni.
    const SKILL_TAG_CATALOG = [
        {id: 'area', icon: 'mdi-earth', predicate: (s) => !!s.spread},
        {id: 'lunge', icon: EFFECT_ICONS.LUNGE, predicate: (s) => s.effect === 'LUNGE'},
        {id: 'piercing', icon: EFFECT_ICONS.PIERCING, predicate: (s) => s.effect === 'PIERCING'},
        {id: 'stun', icon: EFFECT_ICONS.STUN, predicate: (s) => s.effect === 'STUN'},
        {id: 'heal', icon: EFFECT_ICONS.HEAL, predicate: (s) => s.effect === 'HEAL'},
        {id: 'lifesteal', icon: EFFECT_ICONS.LIFESTEAL, predicate: (s) => s.effect === 'LIFESTEAL'},
        // "resistance" (zadani uzivatele) = REFLECT efekt - jedina defenzivni
        // mechanika v datech, kam tenhle nazev sedi (blokuje + odrazi dmg zpet).
        {id: 'resistance', icon: EFFECT_ICONS.REFLECT, predicate: (s) => s.effect === 'REFLECT'},
        {id: 'metronom', icon: EFFECT_ICONS.METRONOM, predicate: (s) => s.effect === 'METRONOM'},
        {id: 'dodge', icon: 'mdi-laser-pointer', predicate: (s) => s.defence === 1},
        {id: 'shield', icon: 'mdi-shield-half-full', predicate: (s) => s.defence > 1},
    ];

    export default {
        name: 'SkillPickerDialog',
        components: {ResponsiveDialog, TypePill},
        props: {
            value: {type: Boolean, default: false},
            skills: {type: Array, default: () => []},
            // 'attack'/'defence'/null (zadani uzivatele 2026-08-17 - "v popup
            // skill pickeru vysvetlit jake je kolo a co vidim za utoky") -
            // stejna hodnota jako SkillActionBar's roundRole, jen tady rovnou
            // meni titulek dialogu + pridava vysvetlujici radek.
            roundRole: {type: String, default: null},
        },
        data() {
            return {
                filtersOpen: false,
                selectedTags: [],
                filterMode: 'OR',
            };
        },
        computed: {
            headerTitle() {
                if (this.roundRole === 'attack') return this.$t('journey.skillPicker.attackTitle');
                if (this.roundRole === 'defence') return this.$t('journey.skillPicker.defenceTitle');
                return this.$t('journey.skillPicker.useSkillTitle');
            },
            roundRoleHint() {
                if (this.roundRole === 'attack') return this.$t('journey.skillPicker.attackHint');
                if (this.roundRole === 'defence') return this.$t('journey.skillPicker.defenceHint');
                return null;
            },
            // Stejne modre/cervene obtazeni jako SkillActionBar.vue (zadani
            // uzivatele 2026-08-17), tady na cely popup - 'skin-card' se
            // musi zachovat (ridi zaobleni rohu, viz ResponsiveDialog.vue),
            // pridava se jen dalsi trida vedle ni.
            cardClass() {
                const roleClass = this.roundRole === 'attack' ? 'skill-picker-card--attack'
                    : this.roundRole === 'defence' ? 'skill-picker-card--defence' : null;
                return roleClass ? ['skin-card', roleClass] : 'skin-card';
            },
            // Pevny katalog + dynamicke typove pilulky za nim (zadani
            // uzivatele - "typy jen ty ktere pokemon ovlada... staci je mit
            // jako dalsi tag pilule"). Puvodne se needitovatelne tagy
            // zobrazovaly zasedle (stabilni layout), ale to na uzoucim
            // mobilu zabiralo zbytecne misto - druhe kolo zadani uzivatele
            // (2026-08-20, "to co je zasedle protoze to vubec neni k
            // dispozici tak vubec nezobrazuj at setrime misto") - tagy bez
            // jedineho odpovidajiciho skillu se rovnou vynechaji.
            allTags() {
                const fixed = SKILL_TAG_CATALOG
                    .filter((tag) => this.skills.some(tag.predicate))
                    .map((tag) => ({...tag, label: this.$t('journey.skillPicker.tag.' + tag.id)}));
                const seenTypes = new Set();
                const typeTags = [];
                this.skills.forEach((s) => {
                    if (s.type && !seenTypes.has(s.type.id)) {
                        seenTypes.add(s.type.id);
                        typeTags.push({
                            id: 'type:' + s.type.id,
                            label: s.type.id,
                            type: s.type,
                            predicate: (sk) => sk.type && sk.type.id === s.type.id,
                        });
                    }
                });
                return [...fixed, ...typeTags];
            },
            filteredSkills() {
                if (!this.selectedTags.length) {
                    return this.skills;
                }
                const active = this.allTags.filter((t) => this.selectedTags.includes(t.id));
                if (!active.length) {
                    return this.skills;
                }
                return this.skills.filter((s) =>
                    this.filterMode === 'AND' ? active.every((t) => t.predicate(s)) : active.some((t) => t.predicate(s))
                );
            },
        },
        methods: {
            getEffectFormula,
            effectIcon,
            effectValue,
            // Stejna paleta jako TypePill.vue - tagove pilulky pro typy
            // pouzivaji obycejny v-chip (ne primo TypePill), protoze
            // v-chip-group registruje vyber jen na primych v-chip potomcich
            // ve stromu komponent, ne skrz obalovou komponentu. Sdileno s
            // Pokedex.vue pres utils/typeColorEnum.js.
            typeChipStyle(type) {
                return typeChipStyle(type.id);
            },
            choose(skill) {
                if (skill.disabled) {
                    return;
                }
                this.$emit('choose', skill);
                this.$emit('input', false);
            },
        },
    }
</script>

<style scoped>
::v-deep .skill-picker-card--attack {
    border: 2px solid var(--v-error-base, #EF5167) !important;
}
::v-deep .skill-picker-card--defence {
    border: 2px solid var(--v-themeJenny-base, #1E88E5) !important;
}
.skill-picker-bg {
    flex: 1 1 auto;
    min-height: 0;
    /* pozadi ridi skin (public/skins/normal.css, .skin-window--skillpicker) */
    display: flex;
    flex-direction: column;
}
.skill-picker-hint {
    margin: 12px 16px 0;
    font-size: 12px;
    opacity: 0.75;
    text-align: center;
    white-space: normal;
    overflow-wrap: break-word;
}
.skill-picker-filter-bar {
    margin: 8px 10px 0;
    flex: 0 0 auto;
}
.skill-picker-filter-toggle {
    cursor: pointer;
}
.skill-picker-filter-panel {
    margin-top: 8px;
    padding: 8px;
    border-radius: 10px;
    background: rgba(0,0,0,0.25);
}
.skill-picker-filter-mode {
    margin-top: 4px;
}
/* Kontrastni zvyrazneni vybraneho tagu (zadani uzivatele 2026-08-20 -
   "oak oranzovou", pak upresneno - "ne cela barva, jen outline, a fajfka
   tam nema byt vubec" - proto zadny `filter` prop na v-chip, jen ramecek).
   ::v-deep + !important, protoze u typovych pilulek by border-color jinak
   prebila inline :style s barvou typu jen z casti (border neni soucasti
   typeChipStyle, ale specificita jinak porovnava). */
::v-deep .skill-picker-chip--active {
    border: 2px solid #FB8C00 !important;
}
.skill-picker-list {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    /* rezerva pro plovouci zaviraci krizek (ResponsiveDialog) - sjednoceno na
       69px (zadani uzivatele 2026-07-24, patem kolo), stejna hodnota jako
       ostatni next/ popupy. Horizontalni padding zmenseno 16->10px (zadani
       uzivatele 2026-08-20 - "mensi okraje, chceme ziskat prostor do
       sirky"). */
    padding: 10px 10px 69px 10px;
    /* Container query pro postupne pridavani Efekt/Formule sloupcu podle
       skutecne sirky listu (2026-08-12, zadani uzivatele), stejny vzor jako
       PokemonDetail.vue - viz docs/superpowers/specs/2026-08-12-
       skill-picker-responsive-info-design.md. Prahy snizeny 2026-08-20
       (zadani uzivatele) - puvodni 460/560px byly na realnem mobilu
       (343-414px sirky, i po odectenim paddingu) nedosazitelne vubec, sloupce
       tak byly na mobilu mrtvy kod bez ohledu na padding/font zmenseni. */
    container-type: inline-size;
}
.skill-picker-row {
    display: flex;
    align-items: center;
    gap: 6px;
    background: rgba(255,255,255,0.75);
    border-radius: 10px;
    padding: 8px 10px;
    margin-bottom: 6px;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    color: #000;
}
.skill-picker-row--disabled {
    opacity: 0.45;
    cursor: default;
    pointer-events: none;
}
/* Zadani uzivatele 2026-08-11 - "pokud se meni pozadi, musi se menit
   inverzne i text bez toho to nejde": .skill-picker-row melo natvrdo
   svetle pozadi + cerny text/ikonu (color:#000 vyse) bez ohledu na theme.
   Tahle varianta (pridana v-class podminecne na $vuetify.theme.dark, viz
   sablona) invertuje pozadi i text spolu - .skill-picker-dmg dedi
   color: #000 z rodice jinak (rgba(0,0,0,0.7) je jen jina pruhlednost
   stejne cerne), takze potrebuje vlastni override taky. */
.skill-picker-row--dark {
    background: rgba(0,0,0,0.75);
    color: #fff;
}
.skill-picker-row--dark .skill-picker-dmg {
    color: rgba(255,255,255,0.7);
}
.skill-picker-name {
    flex: 1 1 auto;
    font-weight: 700;
    font-size: 14px;
    /* S pribyvajicimi sloupci (Efekt/Formule) potrebuje jmeno umet se
       zkratit misto zalomeni radku na dve linky. */
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 0;
}
.skill-picker-dmg {
    flex: none;
    font-size: 12px;
    color: rgba(0,0,0,0.7);
}
.skill-picker-empty {
    text-align: center;
    font-size: 16px;
    font-weight: 700;
    color: rgba(0,0,0,0.6);
    padding-top: 24px;
}
.skill-picker-effect {
    display: none;
    flex: none;
    font-size: 12px;
    color: rgba(0,0,0,0.6);
}
.skill-picker-row--dark .skill-picker-effect {
    color: rgba(255,255,255,0.6);
}
/* Kompaktni varianta vedle ikonky efektu (jen ciselna hodnota, viz
   effectValue()) - na rozdil od .skill-picker-effect NENI container-gated,
   musi byt viditelna i na ultra uzkem rozliseni (zadani uzivatele
   2026-08-20, ctvrte kolo). */
.skill-picker-effect-value {
    flex: none;
    font-size: 12px;
    color: rgba(0,0,0,0.6);
}
.skill-picker-row--dark .skill-picker-effect-value {
    color: rgba(255,255,255,0.6);
}
@container (min-width: 260px) {
    .skill-picker-effect {
        display: inline-block;
    }
}
.skill-picker-formula {
    display: none;
    flex: none;
    font-size: 12px;
    color: rgba(0,0,0,0.6);
}
.skill-picker-row--dark .skill-picker-formula {
    color: rgba(255,255,255,0.6);
}
@container (min-width: 340px) {
    .skill-picker-formula {
        display: inline-block;
    }
}
</style>
